export const heroContent = {
  headline: '发现你的创造力',
  subheadline: '用镜头记录生活，用创意打动世界',
  description: '香蕉视频汇聚全球超过2000万创作者，每天产生数十万条原创短视频。无论你是想发现有趣的视频、学习新技能，还是展示自己的才华，这里都是你最好的舞台。',
  ctaPrimary: '立即下载',
  ctaSecondary: '了解更多',
};

export const features = [
  {
    icon: 'ri-lightbulb-flash-line',
    title: 'AI智能推荐',
    description: '基于深度学习算法，精准推荐你感兴趣的内容，越刷越懂你，发现更多精彩创作与趣味生活。',
  },
  {
    icon: 'ri-magic-line',
    title: '强大创作工具',
    description: '内置丰富滤镜、特效、音乐库和AI辅助剪辑功能，让每个人都能轻松成为专业创作者。',
  },
  {
    icon: 'ri-group-line',
    title: '活跃互动社区',
    description: '弹幕、评论、合拍、挑战赛等多元互动方式，让观看不再孤独，让创作更有温度与共鸣。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全内容生态',
    description: '严格的内容审核机制与青少年保护模式，为每一位用户营造健康、安全的短视频体验环境。',
  },
  {
    icon: 'ri-trophy-line',
    title: '创作者激励计划',
    description: '提供丰厚的创作收益、流量扶持和专业培训，助力每一位有才华的创作者实现梦想与价值。',
  },
  {
    icon: 'ri-global-line',
    title: '全球内容聚合',
    description: '覆盖30+国家和地区，支持多语言内容，让你足不出户感受世界各地的文化与创意魅力。',
  },
];

export const popularContent = [
  {
    id: 1,
    title: '爆笑合集：办公室里的那些糗事，笑到停不下来',
    category: '搞笑',
    author: '开心小达人',
    views: '1280万',
    likes: '86.5万',
    duration: '02:35',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20funny%20office%20comedy%20scene%20with%20people%20laughing%20hysterically%20at%20a%20desk%2C%20bright%20modern%20office%20interior%20with%20warm%20lighting%2C%20casual%20office%20outfits%2C%20candid%20photography%20style%20with%20soft%20natural%20light%2C%20clean%20minimal%20background%20with%20plants&width=640&height=800&seq=popular-01&orientation=portrait',
  },
  {
    id: 2,
    title: '五分钟学会红烧肉，大厨手把手教你做正宗家常味',
    category: '美食',
    author: '厨房小能手',
    views: '980万',
    likes: '72.3万',
    duration: '04:50',
    thumbnail: 'https://readdy.ai/api/search-image?query=Delicious%20braised%20pork%20belly%20dish%20hong%20shao%20rou%20in%20a%20beautiful%20ceramic%20bowl%2C%20steaming%20hot%20with%20garnished%20green%20onions%2C%20warm%20kitchen%20setting%20with%20wooden%20table%2C%20soft%20overhead%20lighting%2C%20food%20photography%20style%20with%20shallow%20depth%20of%20field%2C%20clean%20minimal%20background&width=640&height=800&seq=popular-02&orientation=portrait',
  },
  {
    id: 3,
    title: '城市夜景延时摄影，看见不一样的北上广深',
    category: '旅行',
    author: '光影捕手',
    views: '1560万',
    likes: '98.1万',
    duration: '01:48',
    thumbnail: 'https://readdy.ai/api/search-image?query=Stunning%20city%20nightscape%20timelapse%20view%20with%20illuminated%20skyscrapers%20and%20flowing%20traffic%20light%20trails%2C%20modern%20urban%20skyline%20with%20colorful%20neon%20lights%20reflecting%20on%20water%2C%20dramatic%20twilight%20sky%2C%20professional%20cityscape%20photography%20with%20long%20exposure%2C%20warm%20and%20cool%20tone%20contrast&width=640&height=800&seq=popular-03&orientation=portrait',
  },
  {
    id: 4,
    title: '零基础学吉他，三分钟掌握最常用的四个和弦',
    category: '音乐',
    author: '音乐教室',
    views: '720万',
    likes: '55.6万',
    duration: '03:15',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20person%20playing%20acoustic%20guitar%20in%20a%20cozy%20room%20with%20warm%20ambient%20lighting%2C%20fingers%20on%20guitar%20fretboard%20closeup%2C%20wooden%20interior%20with%20soft%20shadows%2C%20music%20learning%20atmosphere%2C%20clean%20simple%20composition%20with%20bokeh%20background&width=640&height=800&seq=popular-04&orientation=portrait',
  },
  {
    id: 5,
    title: '科技改变生活：2025年最值得入手的智能家居推荐',
    category: '科技',
    author: '数码极客',
    views: '890万',
    likes: '63.2万',
    duration: '05:20',
    thumbnail: 'https://readdy.ai/api/search-image?query=Modern%20smart%20home%20setup%20with%20various%20smart%20devices%20and%20gadgets%20on%20a%20minimalist%20white%20desk%2C%20warm%20indirect%20lighting%2C%20clean%20contemporary%20interior%20design%2C%20product%20photography%20style%20with%20soft%20shadows%20and%20neutral%20background&width=640&height=800&seq=popular-05&orientation=portrait',
  },
  {
    id: 6,
    title: '街舞Battle精彩集锦，高能动作燃爆全场',
    category: '舞蹈',
    author: '舞动青春',
    views: '2100万',
    likes: '135.4万',
    duration: '03:02',
    thumbnail: 'https://readdy.ai/api/search-image?query=Dynamic%20street%20dance%20battle%20scene%20with%20dancer%20performing%20power%20move%20in%20urban%20setting%2C%20dramatic%20stage%20lighting%20with%20colored%20spotlights%2C%20energetic%20atmosphere%20with%20crowd%20silhouettes%2C%20motion%20blur%20effect%2C%20vibrant%20warm%20and%20cool%20color%20contrast&width=640&height=800&seq=popular-06&orientation=portrait',
  },
];

export const creators = [
  {
    name: '李小美',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20woman%20portrait%20with%20warm%20smile%2C%20casual%20stylish%20outfit%2C%20soft%20natural%20lighting%2C%20clean%20neutral%20background%2C%20professional%20headshot%20photography%20with%20shallow%20depth%20of%20field&width=200&height=200&seq=creator-01&orientation=squarish',
    followers: '580万',
    category: '美食达人',
    description: '分享家常美食制作，让每个人都能成为厨房小能手',
  },
  {
    name: '旅行阿杰',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20man%20portrait%20with%20friendly%20expression%2C%20outdoor%20adventure%20style%20clothing%2C%20warm%20golden%20hour%20lighting%2C%20clean%20natural%20background%2C%20professional%20headshot%20photography%20with%20soft%20bokeh&width=200&height=200&seq=creator-02&orientation=squarish',
    followers: '420万',
    category: '旅行博主',
    description: '走遍中国每个角落，带你发现最美的风景与人情',
  },
  {
    name: '音乐小王子',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20male%20musician%20portrait%20with%20creative%20artistic%20look%2C%20stylish%20casual%20outfit%2C%20soft%20studio%20lighting%2C%20clean%20minimal%20background%2C%20professional%20headshot%20photography&width=200&height=200&seq=creator-03&orientation=squarish',
    followers: '890万',
    category: '音乐创作',
    description: '原创音乐人，用旋律讲述生活中的每一个故事',
  },
  {
    name: '科技喵',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20woman%20portrait%20with%20tech%20style%2C%20modern%20glasses%2C%20warm%20confident%20expression%2C%20clean%20studio%20lighting%2C%20minimal%20background%2C%20professional%20headshot%20photography&width=200&height=200&seq=creator-04&orientation=squarish',
    followers: '350万',
    category: '数码评测',
    description: '客观专业的数码产品评测，帮你做出最优选择',
  },
];

export const stats = [
  { value: '2亿+', label: '全球用户' },
  { value: '2000万+', label: '活跃创作者' },
  { value: '50亿+', label: '日播放量' },
  { value: '30+', label: '覆盖国家' },
];

export const faqs = [
  {
    question: '香蕉视频是免费使用的吗？',
    answer: '是的，香蕉视频完全免费下载和使用。我们提供丰富的免费滤镜、特效和音乐库，您无需支付任何费用即可享受完整的创作和观看体验。部分高级功能为可选订阅。',
  },
  {
    question: '如何在香蕉视频上发布自己的视频？',
    answer: '下载香蕉视频App后，点击底部中间的"+"按钮，您可以选择拍摄新视频或从相册上传。使用内置编辑工具添加音乐、滤镜和特效后，填写标题和标签即可发布。',
  },
  {
    question: '香蕉视频的内容审核标准是什么？',
    answer: '我们严格遵守社区准则，采用AI智能审核与人工审核相结合的方式，对违规内容零容忍。我们致力于打造一个健康、积极、富有创意的短视频社区环境。',
  },
  {
    question: '创作者如何获得收益？',
    answer: '香蕉视频为创作者提供多元化的收益渠道，包括创作激励基金、直播打赏、品牌合作、电商带货等。粉丝量达到一定标准的创作者可申请加入创作者激励计划。',
  },
  {
    question: '香蕉视频支持哪些设备？',
    answer: '香蕉视频支持iOS和Android手机设备，您可以在Apple App Store和各大安卓应用商店下载。同时我们也提供Web网页版，方便在电脑上浏览内容。',
  },
];